"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _Error = _interopRequireDefault(require("@material-ui/icons/Error"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _RelatedContentCard = require("../RelatedContentCard");
var _graphqlTypes = require("../_types/graphql-types");
var _getProductsListUtils = require("../_utils/getProductsListUtils");
var __jsx = _react.default.createElement; // import {appClient as client} from '../App'
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    wrapper: {},
    title: {
      display: 'block',
      fontSize: theme.typography.pxToRem(20),
      lineHeight: '1.2em',
      fontWeight: 900,
      margin: '24px 0 16px',
      textTransform: 'uppercase',
      '.aem-Grid--default--3 &, .aem-Grid--default--4 &': {
        fontSize: theme.typography.pxToRem(18),
        textTransform: 'initial'
      }
    },
    list: {
      width: '100%'
    },
    error: {
      padding: theme.spacing(6, 5, 3),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center'
    },
    noProducts: {
      textAlign: 'center',
      padding: theme.spacing(2, 2),
      borderBottom: "1px solid ".concat(theme.palette.grey[300])
    }
  };
});
var RelatedRightRailComponentConfig = {
  emptyLabel: 'Configure Related Products - Right Rail',
  isEmpty: function isEmpty(props) {
    if (props.products && props.products.length > 0) {
      return false;
    } else {
      return true;
    }
  }
};
var RelatedProductsRightRail = function RelatedProductsRightRail(_ref) {
  var title = _ref.title,
    products = _ref.products,
    totalProductsDisplay = _ref.totalProductsDisplay;
  var classes = useStyles();
  var updatedProductInputs = (0, _getProductsListUtils.getUpdatedInputsBasedOnCatalogType)(products);
  var productInputs = updatedProductInputs === null || updatedProductInputs === void 0 ? void 0 : updatedProductInputs.map(function (_ref2) {
    var brandKey = _ref2.brandKey,
      productKey = _ref2.productKey,
      catalogType = _ref2.catalogType;
    return {
      brandKey: brandKey,
      productKey: productKey,
      catalogType: catalogType
    };
  });
  var _useMultipleProductDe = (0, _graphqlTypes.useMultipleProductDetailPartialProductsQuery)({
      variables: {
        productInputs: productInputs
      },
      errorPolicy: 'ignore',
      ssr: false
      // client
    }),
    loading = _useMultipleProductDe.loading,
    error = _useMultipleProductDe.error,
    data = _useMultipleProductDe.data;
  if (loading) return __jsx("div", {
    className: classes.wrapper
  });
  if (error) {
    console.error(error);
    if (products && products.length > 0) {
      return __jsx("div", {
        className: classes.error
      }, __jsx(_Error.default, null), __jsx("span", null, "Something went wrong, please try again."));
    } else {
      return null;
    }
  } else {
    var relatedProductData = data ? data.getMultipleProductDetails : [];
    return __jsx("div", {
      "aria-labelledby": "Related Product Right Rail",
      className: "aem-ms-cmp aem-ms-grid-view aem-ms-related-product-right-rail"
    }, title && __jsx(_core.Typography, {
      component: "strong",
      className: classes.title,
      dangerouslySetInnerHTML: {
        __html: title
      }
    }), __jsx("ul", null, relatedProductData && relatedProductData.map(function (product, index) {
      var _product$browserMetad;
      if (!product) return null;
      var productDescription = product.description && product.description != null ? product.description : product === null || product === void 0 ? void 0 : (_product$browserMetad = product.browserMetadata) === null || _product$browserMetad === void 0 ? void 0 : _product$browserMetad.description;
      if (index < totalProductsDisplay) {
        return __jsx("li", {
          className: classes.list,
          key: index
        }, __jsx(_RelatedContentCard.RelatedContentCard, {
          url: '/product/' + product.brand.key + '/' + product.productNumber,
          title: product.name,
          text: productDescription || '',
          maxTitleLines: 2
        }));
      } else {
        return false;
      }
    })));
  }
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/relatedproductsrightrail')(RelatedProductsRightRail, RelatedRightRailComponentConfig);
exports.default = _default;